<template>
  <div style="padding-bottom: 400px;">
    <!-- handle=".handle" -->
    <draggable
      :value="active_list"
      @change="orderChange"
      ghost-class="ghost"
      handle=".handle"
      :setData="setData"
      :swapThreshold="0.7"
      :invertSwap="true"
    >
      <transition-group type="transition" name="flip-list">
        <ListItem
          v-for="(item, index) in active_list"
          :key="item.id"
          :item="item"
          :index="index"
          :unlocked="unlocked"
        />
      </transition-group>
    </draggable>

    <v-card
      v-if="!$store.getters.active_list.length"
      flat
      class="noData mt-5 text-center text-overline py-10 grey--text text--lighten-1 rounded-lg"
      outlined
    >
      add urls / folders or
      <router-link to="/import">import</router-link>
    </v-card>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import ListItem from "./ListItem";

export default {
  name: "list",
  components: { ListItem, draggable },
  watch: {
    edit_mode(value) {
      if (!value) {
        this.$store.commit("selectAll", false);
      }
    },
  },
  computed: {
    active_list: {
      get() {
        return this.$store.getters.active_list;
      },
      set(value) {
        console.log(value, "value");
        // this.$store.commit("updateStateFormURL", { location: value });
      },
    },
    edit_mode: {
      get() {
        return this.$store.state.edit_mode;
      },
      set(value) {
        this.$store.commit("updateStateVariable", { edit_mode: value });
      },
    },
    unlocked() {
      return this.$store.state.lock.unlocked;
    },
  },
  methods: {
    orderChange(value) {
      console.log(value, "orderChange");
      // exit if item is on a folder (sortable)
      if (this.$store.state.drag_on_folder) return;
      console.log(value, "orderChange");
      const id = value.moved.element.id;
      const oldIndex = value.moved.oldIndex;
      const newIndex = value.moved.newIndex;
      this.$store.dispatch("changeOrder", {
        id,
        oldIndex,
        newIndex,
      });
    },
    setData(dataTransfer, dragEl) {
      console.log("setData");
      dataTransfer.setData("item_id", dragEl.getAttribute("id"));
      // console.log(dragEl, "dragEl");

      let label = dragEl.querySelector(".label");
      let labelText = "No title";
      if (label) {
        labelText = label.innerText || "No title";
      }

      var crt = document.createElement("div");
      crt.innerText = labelText.length > 20 ? labelText.substring(0, 20) + "..." : labelText;
      crt.classList.add("dragItem");
      document.body.appendChild(crt);
      dataTransfer.setDragImage(crt, 50, 50);
    },
  },
};
</script>

<style>
.flip-list-move {
  transition: transform 0.5s;
}
.ghost {
  opacity: 0.5;
}
.noData {
  background-color: rgba(155, 155, 155, 0.062) !important;
}
.item-active {
  background-color: rgba(114, 114, 114, 0.267);
}
.dragItem {
  font-family: Roboto;
  color: white;
  background-color: var(--v-primary-base);
  padding: 5px 10px;
  display: inline-block;
  font-size: 12px;
}
</style>
